import { debounce } from '../../common/utils/debounce.js';

const SELECTORS = {
    reviewStarsContainer: '#product_just_stars > div.SA__review_widget_item',
    reviewIOStarsContainer: '#review_io_container',
    rcaSubscriptionForm: '.rca-subscription-form',
    rcaButtonLeft: '.rca-button-left',
    rcaButtonRight: '.rca-button-right',
    rcaSelectedButton: 'rca-subscription-form__button--selected',
    shipsEveryLeft: '.ships-every-button-left',
    shipsEvertRight:'.ships-every-button-right',
    shipsEverySelectedButton:'ships-every-subscription-form__button--selected',
    disabledFrequencyElement: '#subscription-frequency-disabled',
    priceOrDivider: '#prAutoShippingPricing-or',
    priceDisplaySpan: '#prAutoShippingPricing > span',
    priceDisplayContainer: '#prAutoShippingPricing',
    subscriptionDiscountDiv: '#sub-discount-price',
    addToCartForm: '#bigCommerceAddToCartForm',
    shipsEverySubscribeText: '#shipsEverySubscribeText',
};

const API_BASE_URLS = {
    production: 'https://api.storesupply.com',
    staging: 'https://onlineservices.storesupply.com',
};

function saLoadScript(src) {
    const script = document.createElement('script');
    script.src = src;
    document.head.appendChild(script);
}


const USD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

function updateReviewWidget(skus, siteId, review_widgetId) {
    const reviewStarsContainer = document.querySelector(SELECTORS.reviewStarsContainer);
    const reviewIOStarsContainer = document.querySelector(SELECTORS.reviewIOStarsContainer);
    // Guard Clause: If the widget container doesn't exist, do nothing.
    if (!reviewStarsContainer  && !reviewIOStarsContainer) {
        console.debug("Review widget containers not found.");
        return;
    }

    let processedSku = skus;
    // Guard Clause: Ensure SKU is a string before calling string methods.
    if (typeof processedSku === 'string' && processedSku.endsWith('BC')) {
        processedSku = processedSku.slice(0, -2);
    }

    if(reviewIOStarsContainer){
        const currentSku = reviewIOStarsContainer.getAttribute('data-sku');

        // Only replace and reinitialize if the SKU has changed
        if (currentSku !== processedSku) {
            // Create new review container with updated SKU
            const newReviewContainer = document.createElement('div');
            newReviewContainer.id = 'review_io_container';
            newReviewContainer.className = 'ruk_rating_snippet';
            newReviewContainer.setAttribute('data-sku', processedSku);

            // Carry the per-store reviews.io store id forward onto the replacement
            // node so subsequent SKU changes continue to find it.
            const existingStoreId = reviewIOStarsContainer.getAttribute('data-store-id');
            if (existingStoreId) {
                newReviewContainer.setAttribute('data-store-id', existingStoreId);
            }

            // Replace the old container with the new one
            reviewIOStarsContainer.replaceWith(newReviewContainer);

            // Initialize the Review.io widget after DOM update
            if (window.ratingSnippet && typeof window.ratingSnippet === 'function') {
                const storeId = newReviewContainer.dataset.storeId;
                if (storeId) {
                    window.ratingSnippet("ruk_rating_snippet", {
                        store: storeId,
                        color: "#eb7100",
                        linebreak: false,
                        usePolaris: true,
                        text: "Reviews"
                    });
                    console.debug("Review.io widget reinitialized for SKU:", processedSku, "store:", storeId);
                } else {
                    console.warn("ratingSnippet: data-store-id missing on #review_io_container; skipping re-init");
                }
            } else {
                console.warn("ratingSnippet function not available on window object");
            }
        } else {
            console.debug("Review.io SKU unchanged:", processedSku);
        }
    }

    if (reviewStarsContainer) {
        reviewStarsContainer.classList.remove('SA__review_widget_item');
        reviewStarsContainer.style.display = 'none';

        // Guard against the getAttribute target being missing
        const skuSource = reviewIOStarsContainer ?? reviewStarsContainer;
        const currentSku = skuSource.getAttribute('data-sku-sh-review');

        // Validate inputs before building a script URL
        if (currentSku !== processedSku && processedSku && siteId && review_widgetId) {
            const scriptUrl = `//www.shopperapproved.com/widgets/${encodeURIComponent(siteId)}/product/${encodeURIComponent(processedSku)}/product-widget/${encodeURIComponent(review_widgetId)}.js`;

            try {
                saLoadScript(scriptUrl);
                console.debug("Shopper Approved widget script loaded for SKU:", processedSku);
                reviewStarsContainer.setAttribute('data-sku-sh-review', processedSku);
            } catch (e) {
                console.error("Failed to load Shopper Approved widget:", e);
                reviewStarsContainer.style.display = ''; // Re-show on failure
            }
        }
    }

}


export async function getProductModifiers(productId, url, appId, storeHash) {
    // Guard Clause: Ensure required parameters are present.
    if (!productId || (!appId && !storeHash)) {
        console.warn("getProductModifiers called with invalid parameters.");
        return null;
    }

    //const baseUrl = url ? `${API_BASE_URLS.staging}/products/Product/GetExtraPdpInfo` : `${API_BASE_URLS.production}/products/Product/GetExtraPdpInfo`;
    console.log("Service Url: " + url);
    //onst baseUrl = url != null ? `https://onlineservices.storesupply.com/products/Product/GetExtraPdpInfo?productId=${productId}&variantId=null&appId=${appId}&storeHash=${storeHash}` : `https://api.storesupply.com/products/Product/GetExtraPdpInfo?productId=${productId}&variantId=&appId=${appId}&storeHash=${storeHash}`;


    const baseUrl = `${url}products/Product/GetExtraPdpInfo`;

    // Only append params we actually have. URLSearchParams stringifies null as
    // the literal "null", so the storefront used to send variantId=null and
    // storeHash=null on every PDP view (all callers pass storeHash null).
    const params = new URLSearchParams({ productId });
    if (appId) {
        params.set('appId', appId);
    }
    if (storeHash) {
        params.set('storeHash', storeHash);
    }

    const fullUrl = `${baseUrl}?${params.toString()}`;

    try {
        const response = await fetch(fullUrl);
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        let subscribeOption = result?.data?.find(opt => opt.display_name === "Subscribe");
        if(!subscribeOption){
            subscribeOption = result?.data?.find(opt => opt.display_name === "Ships Every");
        }

        if (!subscribeOption?.option_values?.[0]?.adjusters?.price) {
            console.warn(
                "API response for modifiers is missing expected data structure for 'Subscribe' or 'Ships Every'.",
                result
            );
            return null;
        }

        // At this point, we know it exists:
        console.log("Price adjuster found:", subscribeOption.option_values[0].adjusters.price);

        return result;

    } catch (error) {
        console.error("Error fetching or parsing product modifiers:", error);
        return null;
    }
}
function updateSubscriptionPriceDisplay(discountedPrice, discount,subscription_modifier_label_discount) {
    const priceOrDivider = document.querySelector(SELECTORS.priceOrDivider);
    const priceDisplaySpan = document.querySelector(SELECTORS.priceDisplaySpan);
    const priceDisplayContainer = document.querySelector(SELECTORS.priceDisplayContainer);


    if (!priceOrDivider || !priceDisplaySpan || !priceDisplayContainer) {
        console.warn("One or more subscription pricing elements are missing from the DOM.");
        return;
    }
    const subscribeButton = document.querySelector(SELECTORS.rcaButtonRight);
    //let finalPrice = price;
    const shipsEverySubscribeText = document.querySelector(SELECTORS.shipsEverySubscribeText);
    if(shipsEverySubscribeText){
        shipsEverySubscribeText.innerText = `${subscription_modifier_label_discount} ${Math.abs(discount)}%`;
    }


    const isSubscribed = subscribeButton?.classList.contains(SELECTORS.rcaSelectedButton);


    priceDisplaySpan.innerText = USD.format(discountedPrice);
    priceOrDivider.style.display = 'block';
    priceDisplaySpan.style.display = 'block';
    priceDisplayContainer.style.display = 'block';
    // if(isSubscribed){
    //     priceOrDivider.style.opacity = '0%';
    //     priceDisplaySpan.style.opacity = '0%';
    //     priceDisplayContainer.style.opacity = '0%';
    // }
    // else{
    //     priceOrDivider.style.opacity = '100%';
    //     priceDisplaySpan.style.opacity = '100%';
    //     priceDisplayContainer.style.opacity = '100%';
    // }
}

async function applySubscriptionPriceDisplay(price, productId, url, appId, storeHash,subscription_modifier_label_discount) {
    if (price == null) {
        return;
    }

    let discount = null;
    const subscriptionDiscountDiv = document.querySelector(SELECTORS.subscriptionDiscountDiv);

    if (subscriptionDiscountDiv) {

        discount = parseFloat(subscriptionDiscountDiv.dataset.subDiscount);
    } else {
        const modifiers = await getProductModifiers(productId, url, appId, storeHash);


        let subscribeModifier = modifiers?.data?.find(
            mod => mod.display_name === "Subscribe"
        );

        if(typeof subscribeModifier == 'undefined' || subscribeModifier == null){
            subscribeModifier = modifiers?.data?.find(
            mod => mod.display_name === "Ships Every");
        }

        const fetchedDiscount = subscribeModifier?.option_values?.[0]?.adjusters?.price?.adjuster_value;

        const subscriptionDiscountDivBackup = document.querySelector(SELECTORS.subscriptionDiscountDiv);
        if (!subscriptionDiscountDivBackup) {
            if (typeof fetchedDiscount === 'number') {
                discount = fetchedDiscount;
                const addToCartForm = document.querySelector(SELECTORS.addToCartForm);
                if (addToCartForm) {
                    const newDiscountDiv = document.createElement('div');
                    newDiscountDiv.id = SELECTORS.subscriptionDiscountDiv.substring(1);
                    newDiscountDiv.dataset.subDiscount = discount;
                    newDiscountDiv.style.display = 'none';
                    addToCartForm.after(newDiscountDiv);
                }
            }
        }

    }

    if (discount == null || isNaN(discount)) {
        console.warn("Could not determine subscription discount.");
        console.warn("productId: ", productId);
        console.warn(productId, url, appId, storeHash);
        return;
    }
    if (discount === 0) {
        console.log("Subscription discount is 0.");
        return;
    }


    const subscribeButton = document.querySelector(SELECTORS.rcaButtonRight);
    
    const shipsEveryButton = document.querySelector(SELECTORS.shipsEvertRight);
    
    let finalPrice = price;

    const isSubscribed = subscribeButton?.classList.contains(SELECTORS.rcaSelectedButton) || shipsEveryButton?.classList.contains(SELECTORS.shipsEverySelectedButton);
    if (!isSubscribed) {
        finalPrice = price * (1 + (discount / 100));
    }

    //console.debug("Applying subscription price display. Final price:", finalPrice);
    updateSubscriptionPriceDisplay(finalPrice, discount,subscription_modifier_label_discount);
}

async function productDetailsChange(skus, siteId, price = null, productId, url, appId = null, storeHash = null, custom_fields, review_widgetId, metaFieldArray = null, productModifiers = null,subscription_modifier_label_discount = null) {
    //console.debug("productDetailsChange START");

    updateReviewWidget(skus, siteId, review_widgetId);
    const fieldsHelper = new CustomFieldsHelper(custom_fields);


    const customizableSkusString = fieldsHelper.getField('CustomizableSkus');
    const configuratorUrl = fieldsHelper.getField('ConfiguratorUrl');

    renderCustomizerButton(skus, customizableSkusString, configuratorUrl, 'bigCommerceAddToCartForm');

    await applySubscriptionPriceDisplay(price, productId, url, appId, storeHash,subscription_modifier_label_discount);
    // (function () {
    //     const handled = new WeakSet();

    //     function handle(container) {
    //         if (handled.has(container)) return;
    //         const carousel = container.querySelector('.ss__carousel.ss__carousel__recommendation');
    //         if (!carousel) return;
    //         handled.add(container);
    //         // Your code:
    //         if(listingPagesLoaded){
    //             listingPagesLoaded();
    //         }
    //         console.log('Ready:', container, carousel);
    //     }

    //     function watch(container) {
    //         handle(container); // initial check
    //         const ob = new MutationObserver(() => handle(container));
    //         ob.observe(container, { childList: true, subtree: true });
    //     }

    //     // Existing containers
    //     document.querySelectorAll('.ss__recommendation').forEach(watch);

    //     // Future containers
    //     const rootOb = new MutationObserver((list) => {
    //         for (const m of list) {
    //             for (const n of m.addedNodes) {
    //                 if (!(n instanceof Element)) continue;
    //                 if (n.matches('.ss__recommendation')) watch(n);
    //                 n.querySelectorAll?.('.ss__recommendation')?.forEach(watch);
    //             }
    //         }
    //     });
    //     rootOb.observe(document.body, { childList: true, subtree: true });
    // })();

    //console.debug("productDetailsChange END");
}
export const debouncedProductDetailsChange = debounce(productDetailsChange, 150, 'productDetailsChange');
function renderCustomizerButton(currentProductSku, customizableSkusString, configuratorUrl, targetElementId) {

    const container = document.getElementById(targetElementId);
    const existingContainer = document.getElementById('CustomizeThisItemButton');
    if (!currentProductSku || !customizableSkusString || !configuratorUrl || !container) {
        console.log('Customizer button: Missing required data or target element. Aborting.');
        return;
    }


    const customizableSkus = customizableSkusString.split(',').map(sku => sku.trim());


    if (customizableSkus.includes(currentProductSku)) {


        const encodedSku = encodeURIComponent(currentProductSku);
        let skuSuffix = "";
        if (configuratorUrl == '/custombagproduct.aspx') {
            skuSuffix = "92";
        }

        const separator = configuratorUrl.includes('?') ? '&' : '?';
        const finalUrl = `${configuratorUrl}${separator}sku=${encodedSku + skuSuffix}`;


        const span = document.createElement('span');

        const svgNS = "http://www.w3.org/2000/svg";
        const svg = document.createElementNS(svgNS, 'svg');
        svg.setAttribute('fill', '#fff');
        svg.setAttribute('width', '1em');
        svg.setAttribute('height', '1em');
        svg.setAttribute('viewBox', '0 0 365.59 365.591');
        svg.setAttribute('xmlns', svgNS);
        svg.style.width = '16px';
        svg.style.height = '16px';
        svg.style.verticalAlign = 'middle';
        svg.style.flexShrink = '0';

        const path = document.createElementNS(svgNS, 'path');
        path.setAttribute('d', 'M355.458,7.443C350.59,2.574,344.062,0,336.577,0c-10.159,0-29.491,4.533-79.879,43.733 c-33.747,26.256-74.202,62.585-113.913,102.295c-27.837,27.836-50.188,51.875-72.421,77.892 c-18.55,2.251-36.082,13.324-48.41,30.67C3.752,280.201-1.852,316.067,6.176,355.579c0.913,4.495,4.216,8.13,8.604,9.468 c1.199,0.366,2.427,0.544,3.645,0.544c3.237,0,6.404-1.259,8.777-3.599c11.396-11.235,23.931-13.215,39.803-15.723 c12.541-1.979,26.756-4.228,42.625-11.598c22.469-10.438,35.61-28,35.663-47.387c23.235-20.316,47.308-42.907,71.574-67.177 c43.822-43.822,82.673-87.574,109.393-123.195c13.451-17.933,23.277-33.097,29.208-45.071 C359.488,43.723,370.167,22.154,355.458,7.443z M124.188,244.191c-3.499-3.498-7.218-6.6-11.107-9.264 c17.399-19.7,35.844-39.223,57.613-60.992c38.499-38.498,77.571-73.614,110.022-98.883c9.644-7.508,18.572-14.036,26.546-19.419 c-5.382,7.972-11.911,16.904-19.418,26.546c-25.267,32.447-60.383,71.521-98.883,110.021 c-19.855,19.854-40.547,39.45-60.126,56.948C127.375,247.484,125.821,245.827,124.188,244.191z');

        svg.appendChild(path);





        const button = document.createElement('a');
        button.appendChild(svg);
        button.id = 'CustomizeThisItemButton';
        button.href = finalUrl;
        button.style.display = 'inline-flex';
        button.style.alignItems = 'center';
        button.style.gap = '0.5em';
        button.style.justifyContent = 'center';

        button.appendChild(svg);


        const label = document.createElement('span');
        label.textContent = 'Customize this Item';
        button.appendChild(label)

        button.style.backgroundColor = '#ec971f';
        button.style.borderColor = '#ec971f';
        button.style.color = '#fff';
        button.style.width = '100%';
        button.style.marginTop = '10px';
        button.style.marginBottom = '10px';
        button.style.paddingBottom = '.75rem';
        button.style.paddingTop = '.75rem';


        button.className = 'button button--primary customizer-button';


        if (existingContainer) {
            existingContainer.replaceWith(button);
        }
        else {
            container.after(button);
        }

        console.log(`Customizer button created for SKU: ${currentProductSku}`);
    } else {
        console.log(`SKU ${currentProductSku} is not in the customizable list. No button created.`);
        if (existingContainer) {
            existingContainer.remove();
        }
    }
}

function createDisabledFrequencyElement() {
    const container = document.querySelector(SELECTORS.rcaSubscriptionForm);
    const subscriptionToggleButton = document.querySelector(SELECTORS.rcaButtonLeft);

    if (!container || !subscriptionToggleButton) {
        return;
    }

    const isSubscriptionSelected = subscriptionToggleButton.classList.contains(SELECTORS.rcaSelectedButton);

    let frequencyElement = document.querySelector(SELECTORS.disabledFrequencyElement);

    if (!frequencyElement) {
        frequencyElement = document.createElement("label");
        frequencyElement.className = "rca-subscription-form__frequency";
        frequencyElement.id = SELECTORS.disabledFrequencyElement.substring(1);
        frequencyElement.textContent = "Delivery every ";

        const select = document.createElement("select");
        select.className = "rca-subscription-form__frequency-selector";
        select.disabled = true;
        Object.assign(select.style, {
            filter: "grayscale(100%)",
            cursor: "not-allowed",
            backgroundColor: "#f0f0f0",
        });

        const options = ["2 Weeks", "4 Weeks", "6 Weeks", "8 Weeks", "10 Weeks", "12 Weeks"];
        options.forEach(text => {
            const option = document.createElement("option");
            option.className = "rca-subscription-form__frequency-option";
            option.innerText = text;
            select.appendChild(option);
        });

        frequencyElement.appendChild(select);
        container.append(frequencyElement);
    }
    frequencyElement.style.display = isSubscriptionSelected ? 'block' : 'none';
}
function createCustomizeProductButton(currentProductSku, custom_fields) {

}

class CustomFieldsHelper {

    constructor(customFieldsArray) {

        this._processedFields = {};

        if (!Array.isArray(customFieldsArray)) {
            console.error("CustomFieldsHelper: Input data must be an array.", customFieldsArray);
            return;
        }

        for (const field of customFieldsArray) {
            const { name, value } = field;

            if (typeof name === 'undefined' || typeof value === 'undefined') continue;

            if (this._processedFields.hasOwnProperty(name)) {
                const existingValue = this._processedFields[name];
                if (Array.isArray(existingValue)) {
                    existingValue.push(value);
                } else {
                    this._processedFields[name] = [existingValue, value];
                }
            } else {
                this._processedFields[name] = value;
            }
        }
    }

    getField(name) {
        return this._processedFields[name] || null;
    }

    getSingleField(name) {
        const value = this.getField(name);
        if (Array.isArray(value)) {
            return value.length > 0 ? value[0] : null;
        }
        return value;
    }

    getAllFields() {
        return this._processedFields;
    }
}